import Panel from '../panel/Panel';
import { useStores } from '../../stores';
import { Button, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from "react-i18next";
import { Publisher } from '../../domain/Publisher';

const EmergencyContactsPage = observer(() => {
    const { t } = useTranslation();
    const { publisherStore } = useStores();

    const headerItems = () => {
        return [
            <Button
                key="download_excel_btn"
                type="button"
                color="inherit"
                onClick={() => publisherStore.downloadEmergencyContactsExcel()}>
                {t("download_excel")}
            </Button>
        ];
    }

    const rowProps = (publisher: Publisher): React.CSSProperties => {
        return { backgroundColor: publisher.inactive ? '#c628281c' : undefined }
    }

    return (
        <Panel
            title={t("emergency_contacts")}
            headerItems={headerItems()}
        >
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("name")}</TableCell>
                                    <TableCell>{t("address")}</TableCell>
                                    <TableCell>{t("phone_number")}</TableCell>
                                    <TableCell>{t("birth_date")}</TableCell>
                                    <TableCell>{t("emergency_contact")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {publisherStore.publishers && publisherStore.publishers
                                    .map((publisher: Publisher) => (
                                        <TableRow style={rowProps(publisher)} key={publisher.id}>
                                            <TableCell>{`${publisher.lastName} ${publisher.firstName}`}</TableCell>
                                            <TableCell>{publisher.address}</TableCell>
                                            <TableCell>{publisher.phoneNumber}</TableCell>
                                            <TableCell>{publisher.birthDate}</TableCell>
                                            <TableCell>{publisher.emergencyContact}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        </Panel >
    );
});

export default EmergencyContactsPage;